export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_MENU = 'UPDATE_MENU'
export const UPDATE_PERMISSION = 'UPDATE_MENU'
export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const UPDATE_NOTI = 'UPDATE_NOTI'
export const CHANGE_MENU = 'CHANGE_MENU'
export const CHANGE_PHONE_NUMBER = 'CHANGE_PHONE_NUMBER'
export const OPEN_SOFT_PHONE = 'OPEN_SOFT_PHONE'
export const DEPARTMENT_SCREEN = {
  FILTER_SELECTED_COMPANY: 'FILTER_SELECTED_COMPANY'
}
export const UPDATE_ANNUAL_ORDER_DETAIL = 'UPDATE_ANNUAL_ORDER_DETAIL'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js